import React from "react";

function TestComponent() {
  return <h2>hello from the test component</h2>;
}

export default TestComponent;
